







  import { Component } from 'vue-property-decorator'
  import { mixins } from 'nuxt-property-decorator'
  import { Products } from '@one/types'
  import { namespace } from 'vuex-class'
  import CurrentProductMixin from '~/mixins/CurrentProduct'

  const products = namespace('products')

  @Component({
    components: {
      OneProductTechnicalData: () => import('~/components/organisms/product/OneProductTechnicalData.vue'),
    },
  })
  export default class OneProductTechnicalDataSection extends mixins<CurrentProductMixin>(CurrentProductMixin) {
    @products.Getter getAttributesValue: any

    get attributesValue(): Array<Products.Attribute> {
      if (!this.$product) { return [] }
      const attributesValue = this.getAttributesValue(this.$product.id)
      return attributesValue.length ? attributesValue : null
    }
  }
